import React, { useEffect } from 'react';

interface IntelligentAnalysisReportsProps {
  initialView?: "main" | "reports";
  onOpenRightSidebar?: () => void;
}

const IntelligentAnalysisReports: React.FC<IntelligentAnalysisReportsProps> = ({ initialView = "main", onOpenRightSidebar }) => {
  useEffect(() => {
    // Automatically open the right sidebar when this component mounts
    if (onOpenRightSidebar) {
      onOpenRightSidebar();
    }
  }, [onOpenRightSidebar]);

  // Return null to render nothing in the main content area
  // The iframe URL in RightSidebar is determined by the current route (useLocation)
  return null;
};

export default IntelligentAnalysisReports;
